'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

require('../../styles/theme.scss');

require('../../styles/theme.scss.liquid');

require('lazysizes');

require('../components/AddToCart');

require('../components/AddToCartAnyaSubscription');

require('../components/AddToCartSubscriptionGift');

require('../components/CartItem');

require('../components/RedeemGift');

require('../apps/Header');

require('../apps/Cart');

require('../apps/Main');

require('../components/animate-in-view');

require('../components/smooth-scroll');

require('../components/modals');

require('../components/dismissible-notifications');

require('../components/select-dropdown');

require('../components/single-toggle');

require('../components/numbered-slider');

require('../components/feature-slider');

require('../components/ingredients-slider');

require('../components/fullwidth-buttons-slider');

require('../components/plan-preview-slider');

require('../components/tooltips');

require('../components/reviews-slider');

require('../components/section-checker');

require('../components/email-subscribe');

require('../components/modal-auto-show');

require('../components/scroll-direction-indicator');

require('../components/related-posts');

require('../components/next-post');

require('../components/article-progress-bar');

require('../components/social-share');

require('../components/url-select');

require('../components/calculate-container-margin');

require('../sections/top-messaging');

require('../sections/header');

require('../sections/footer');

require('../templates/article');

var _cssVarsPonyfill = require('css-vars-ponyfill');

var _cssVarsPonyfill2 = _interopRequireDefault(_cssVarsPonyfill);

var _vhCheck = require('vh-check');

var _vhCheck2 = _interopRequireDefault(_vhCheck);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Global plugin init

// Sections

// Vue App Instances

/*----------------------------
Scripts - Global
----------------------------*/

// Plugins

/*----------------------------
Styles - Global
----------------------------*/

// Includes all global sections and component styling. Add all global styling direct to the theme.scss so we pull it in as a single import.

document.addEventListener('DOMContentLoaded', (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
  return _regenerator2.default.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          (0, _cssVarsPonyfill2.default)({});
          (0, _vhCheck2.default)();

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _callee, undefined);
})));

// Templates

// Components

// Vue Components